import { getPlacementTask } from '@common/utils';
import { PlacementTask } from 'enums';
import { PartialSubmission } from 'types';
import { createRecipientGroupFromSubmissionCustomer, RecipientGroup } from 'broker/components/Emails/recipient-utils';
import { useGetPlacementTaskEmailRecipients } from 'broker/hooks';

export function useGetProposalEmailRecipients(submission: PartialSubmission): {
  preSelectedRecipients: RecipientGroup[];
  ccEmailsInit: string[];
  bccEmailsInit: string[];
} {
  const sendProposalTask = getPlacementTask(submission, PlacementTask.SendProposal);
  const emailRecipientsConfig = sendProposalTask?.stepConfig?.proposalEmailRecipients;

  const recipients = useGetPlacementTaskEmailRecipients(submission, emailRecipientsConfig);

  // If no 'to' recipients configured, default to submission customer
  const preSelectedRecipients =
    recipients.preSelectedRecipients.length > 0
      ? recipients.preSelectedRecipients
      : [createRecipientGroupFromSubmissionCustomer(submission)];

  return {
    preSelectedRecipients,
    ccEmailsInit: recipients.ccEmailsInit,
    bccEmailsInit: recipients.bccEmailsInit,
  };
}
